import Vue from 'vue'
import Vuex from 'vuex'
import login from './login/store'
import alerts from './alerts/store'
import reservas from './reservas/store'
import compradores from './compradores/store'
import carpetas from './carpetas/store'
import pbc from './pbc/store'
import contratos from './contratos/store'
import contratosFirmantes from './contratosFirmantes/store'
import promociones from './promociones/store'
import promocionesRepresentantes from './promocionesRepresentantes/store'
import modulosOrdenes from './modulosOrdenes/store'
import incrustado from './incrustado/store'
import maestros from './maestros/store'
import configuracion from './configuracion/store'
import documentacion from './documentacion/store'
import pagos from './pagos/store'
import simplificada from './simplificada/store'
import comerciales from './comerciales/store'
import promocionesPlantillas from './promocionesPlantillas/store'
import scoring from './scoring/store'
import textos from './textos/store'
import constantes from './constantes/store'

Vue.use(Vuex)

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    login,
    alerts,
    simplificada,
    reservas,
    compradores,
    carpetas,
    pbc,
    contratos,
    contratosFirmantes,
    promociones,
    promocionesRepresentantes,
    modulosOrdenes,
    incrustado,
    maestros,
    configuracion,
    documentacion,
    pagos,
    comerciales,
    promocionesPlantillas,
    scoring,
    textos,
    constantes
  },
  state: {
    version: 35,
    versionApi: 35,
    showDrawer: false
  },
  mutations: {
    showDrawer (state, payload) {
      state.showDrawer = payload
    }
  },
  actions: {
    showDrawer ({commit}, payload) {
      commit('showDrawer', payload)
    }
  },
  getters: {
    version (state) {
      return state.version
    },
    versionApi (state) {
      return state.versionApi
    },
    showDrawer (state) {
      return state.showDrawer
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js